/* 
* 车辆档案之车辆报警组件 
* 描述：对应车辆的基本信息编辑
* 创建时间：2017-03-31
* 创建人：Shujuan Sun
* 修改人：zhanlz 
* 修改时间：2017-04-21
*/
<template>
	<div class="pl10px pr10px" v-loading="loadingstatus" element-loading-text="加载中">
		<div class="form-horizontal">
			<div class="form-group">
				<label class="col-sm-1 control-label t_center">报警开始时间</label>
				<div class="col-sm-2" v-bind:class="{ 'form-group--error': !validDates }">
					<datepicker v-model="queryParam.almTimeStart" class="form-control" ref="alarmStartFrom"></datepicker>
					<p v-if="!validDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
				</div>
				<label class="col-sm-1 control-label t_center">报警结束时间</label>
				<div class="col-sm-2" v-bind:class="{ 'form-group--error': !validDates }">
					<datepicker v-model="queryParam.almTimeEnd" class="form-control" ref="alarmEndFrom"></datepicker>
					<p v-if="!validDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
				</div>
				<label class="col-sm-1 control-label">处理开始时间</label>
				<div class="col-sm-2" v-bind:class="{ 'form-group--error': !validManageDates }">
					<datepicker v-model="queryParam.handleTimeStart" class="form-control" ref="manageStartFrom"></datepicker>
					<p v-if="!validManageDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
				</div>
				<label class="col-sm-1 control-label">处理结束时间</label>
				<div class="col-sm-2" v-bind:class="{ 'form-group--error': !validManageDates }">
					<datepicker v-model="queryParam.handleTimeEnd" class="form-control" ref="manageEndFrom"></datepicker>
					<p v-if="!validManageDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
				</div>
			</div>
		</div>
		<div class="form-horizontal">
			<div class="form-group">
				<label class="col-sm-1 control-label t_center">报警类型</label>
				<div class="col-sm-2">
					<select class="form-control" v-model="queryParam.almType">
						<option v-for="option in alarmTypeList" v-bind:value="option.udccode">
							{{ option.udcname }}
						</option>
					</select>
				</div>
				<label class="col-sm-1 control-label t_center">紧急度</label>
				<div class="col-sm-2">
					<select class="form-control" v-model="queryParam.almLevel">
						<option v-for="option in alarmLevelList" v-bind:value="option.udccode">
							{{ option.udcname }}
						</option>
					</select>
				</div>
				<label class="col-sm-1 control-label t_center">处理状态</label>
				<div class="col-sm-2">
					<select class="form-control" v-model="queryParam.handleStatus">
						<option v-for="option in alarmHandleStatusList" v-bind:value="option.udccode">
							{{ option.udcname }}
						</option>
					</select>
				</div>
		    <!--<label class="col-sm-1 control-label t_center">处理人</label>
				<div class="col-sm-2">
					<input type="text" class="form-control" v-model="queryParam.handleId">
				</div>-->
			</div>
		</div>
		<div class="form-horizontal">
			<div class="form-group">
				<div class="col-sm-12 text-right">
					<button v-if="permission.indexOf('carFileList_vehicleAlarmReset') == -1" class="btn btn-primary" @click="resetQueryParams">重置</button>
					<button v-if="permission.indexOf('carFileList_vehicleAlarmSelect') == -1" class="btn btn-primary" @click="searchInfo" :disabled="!validDates ||!validManageDates">查询</button>
				</div>
			</div>
		</div>
		<table class="table mb0px table-striped table-bordered">
			<thead>
				<tr>
					<th></th>
					<th>报警类型</th>
					<th>紧急度</th>
					<th>报警时间</th>
					<th>报警内容</th> 
					<th>报警地点</th>
					<th>处理人</th>
					<th>处理时间</th>
					<th>处理状态</th>
					<th>处理结果</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(fileInfo,index) in infoList" v-bind:key="index">
					<td v-if="fileInfo.handleStatus==1" class="text-center">
						<a v-if="permission.indexOf('carFileList_vehicleAlarmDetail') == -1" @click="openDetail(index)">详情</a>
					</td>
					<td v-else class="text-center">
						<a v-if="permission.indexOf('carFileList_vehicleAlarmHandle') == -1" @click="openAlarmHandle(index)">处理</a>
					</td>
					<td>{{fileInfo.almTypeName}}</td>
					<td>{{fileInfo.almLevelName}}</td>
					<td>{{fileInfo.almTime}}</td>
					<td>{{fileInfo.almMessage}}</td> 
					<td>{{fileInfo.address}}</td>
					<td>{{fileInfo.handleName}}</td>
					<td>{{fileInfo.handleTime}}</td>
					<td>{{fileInfo.handleStatusName}}</td>
					<td>{{fileInfo.handleResult}}</td>
					<td class="text-center">
						<a v-if="permission.indexOf('carFileList_vehicleAlarmSite') == -1" @click="alarmScene(fileInfo.id)">现场</a>
					</td>
				</tr>
			</tbody>
		</table>
	    <!--弹框组件开始-->
		<sub-page :show="showSubPage" :bigTitleMsg="bigTitle" v-on:cancel="closeSubPage">
			<div slot="bodycontent">
				<vehicle-alarm-details :detailInfo="detailInfo"  v-on:toClose="closeSubPage"></vehicle-alarm-details>
			</div>
		</sub-page>
		<!--弹框组件结束-->
		  <!--弹框组件开始-->
		<sub-page :show="showAlarmSubPage" :bigTitleMsg="bigTitle" v-on:cancel="closeAlarmSubPage">
			<div slot="bodycontent">
				<page-alarm-handle-edit :data="data"  v-on:toClose="closeAlarmSubPage" v-on:handleSave="savedAlarmSubPage"></page-alarm-handle-edit>
			</div>
		</sub-page>
		<!--弹框组件结束-->
		<!--分页组件开始-->
		<pagination
			v-if="infoList.length>0"
			:pageInfo="pageInfo"
			v-on:getData="getPageNo"
			>						
		</pagination>
		<!--分页组件结束-->
	</div>
</template>
<script>
	import Datepicker from 'components/common/datepicker/Datepicker'
    import Pagination from 'components/common/Pagination'
    import {DICTIONARY_MAP} from 'static/constant'
    import { OPERATE_EXCEPTION } from 'static/message'
    import SubPage from 'components/common/SubPage'
    import vehicleAlarmDetails from 'components/pages/carfile/detail/vehicleAlarmDetails'
    import PageAlarmHandleEdit from 'components/pages/alarmhandle/PageAlarmHandleEdit'
    import {getDictionaryFromArray} from 'util/util'
    import classlist from 'util/classlist'
    
	export default {
		name: 'DetailAlarm',
		components: {
			Datepicker,
			Pagination,
			SubPage,
			vehicleAlarmDetails,
			PageAlarmHandleEdit
		},
		data() {
			return {
				permission:this.$store.state.permission.permission["carFileList"]?this.$store.state.permission.permission["carFileList"]:[],
				loadingstatus:false,
				vehicleInfo: {},
				infoList:[],							//从接口获取的表格数据
				detailInfo:{},					        //车辆报警详情对象
				data:{},	
				showSubPage: false,                     //默认不显示subpage
				showAlarmSubPage: false, 
				bigTitle:"",	                        //传给subPage的标题
				pageInfo:{},							//传给分页组件的属性对象
				pageNo:1,								//从分页组件获取的当前页码数
				//以下为查询属性
				queryParam:{
					almLevel:'',						//紧急度
					almType:'',							//报警种类
					handleStatus:'',				    //报警状态
					handleId:'',						//处理人
					almTimeStart:'',					//报警起始时间
					almTimeEnd:'',						//报警结束时间
					handleTimeStart:'',					//处理结束时间
					handleTimeEnd:'',					//处理起始时间
					page_index:1
				},
				udcType:[
				DICTIONARY_MAP.ALARM_TYPE,
				DICTIONARY_MAP.ALM_LEVEL,
				DICTIONARY_MAP.HANDLE_STATUS,
				],
				alarmTypeList:[],						//报警类型
				alarmLevelList:[],						//紧急度
				alarmHandleStatusList:[],				//处理状态
			}
		},
		beforeMount(){
			Object.assign(this.vehicleInfo, this.$parent.vehicleInfo);
			this.getTableInfo();
			this.getUdc();
		},
		computed: {
			//	起止时间是否合法
			validDates: function(){
				if(this.queryParam.almTimeStart && this.queryParam.almTimeEnd && this.queryParam.almTimeStart > this.queryParam.almTimeEnd){
					return false;
				} else {
					return true;
				}
			},
			//	起止时间是否合法
			validManageDates: function(){
				if(this.queryParam.handleTimeStart && this.queryParam.handleTimeEnd && this.queryParam.handleTimeStart > this.queryParam.handleTimeEnd){
					return false;
				} else {
					return true;
				}
			}
		},
		methods:{
			//查询方法
			searchInfo(){
				this.queryParam.page_index = 1;
				this.getTableInfo();
			},
			//获取车辆报警信息
			getTableInfo() { 
				this.loadingstatus = true;
				this.$http.get(process.env.API_ROOT + "/vehicle/vehicles/" + this.vehicleInfo.vehicleId +"/alarms", {params: this.queryParam})
					.then((response) => {
						if(response.body.success) {
							const resInfo = response.body.data;								
							const {pageNum,pages,total,isFirstPage,isLastPage} = resInfo;
							this.pageInfo = {
								pageNum: pageNum,
								pages: pages,
								total: total,
								isFirstPage: isFirstPage,
								isLastPage: isLastPage
							}
							this.infoList = resInfo.list;
						} else {
							this.$parent.openModal(response.body.message);
						}
						this.loadingstatus = false;
					}, (response) => {
						this.$parent.openModal(response.body.message);
						this.loadingstatus = false;
					})
					.catch((response) => {
						this.$parent.openModal(OPERATE_EXCEPTION);
						this.loadingstatus = false;
					})
			},
			//报警详情
			openDetail(index){
				this.detailInfo = Object.assign({},this.infoList[index]);
				this.showSubPage = true
				this.bigTitle = "车辆报警详情"
				classlist.toggleScroll('close','#carfile-detail',this);
			},
			closeSubPage(){
				this.showSubPage = false;
				classlist.toggleScroll('open','#carfile-detail',this);
			},
			//报警处理
			openAlarmHandle(index){
				this.data = Object.assign({},this.infoList[index]);
				this.showAlarmSubPage = true
				this.bigTitle = "车辆报警处理"
				classlist.toggleScroll('close','#carfile-detail',this);
			},
			closeAlarmSubPage(){
				this.showAlarmSubPage = false;
				classlist.toggleScroll('open','#carfile-detail',this);
			},
			savedAlarmSubPage(){
				this.getTableInfo();
				this.closeAlarmSubPage();
			},
			//从分页组件获取页码参数
			getPageNo(param) {
				this.queryParam.page_index = param;
				this.getTableInfo();
			},
			resetQueryParams:function(){
				this.$refs.alarmEndFrom.handleClear();
				this.$refs.alarmStartFrom.handleClear();
				this.$refs.manageEndFrom.handleClear();
				this.$refs.manageStartFrom.handleClear();
				this.queryParam = {
					almLevel:'',						//紧急度
					almType:'',							//报警种类
					handleStatus:'',				    //报警状态
					handleId:'',						//处理人
					almTimeStart:'',					//报警起始时间
					almTimeEnd:'',						//报警结束时间
					handleTimeStart:'',					//处理结束时间
					handleTimeEnd:'',					//处理起始时间
					page_index:1
				}
			},
			getUdc(){
				if(this.udcType.length ==0) return;			
				let param = this.udcType.join(',');
				this.$http.get(process.env.API_ROOT + '/system/udcs',{params:{udcTypes: param}})
				.then(res => {
					if(res.data.success){	
					 	this.alarmTypeList = getDictionaryFromArray(res.data.data,DICTIONARY_MAP.ALARM_TYPE);
						this.alarmLevelList = getDictionaryFromArray(res.data.data,DICTIONARY_MAP.ALM_LEVEL);
						this.alarmHandleStatusList =getDictionaryFromArray(res.data.data,DICTIONARY_MAP.HANDLE_STATUS);
					}else{
						this.$parent.openModal(res.data.message);
					}
				}, res => {
					this.$parent.openModal(res.data.message);
				}).catch( res => {
					this.$parent.openModal(OPERATE_EXCEPTION);
				})		
			},
			//查看报警现场
			alarmScene(msgId){   
				//1，进入轨迹回放tab
				const obj = {
					name:'车辆轨迹回放',
					code:'vehicleTrace',
					id:'PageVehicleTrace',
					route:'/indexhome/vehicleTrace',
					No:'vehicleTrace'
				}
				this.addTab(obj)
				//2,追加报警现场队列
				const param = {
					almMsgId:msgId,
					vehicleId:this.vehicleInfo.vehicleId
				}
				this.$store.dispatch('addAlarmLive',param)

			},
			addTab(obj){//进入tab窗口
				this.$router.push(obj.route);
				this.$store.dispatch('addTab',obj);
			}

		}
	}
</script>


// WEBPACK FOOTER //
// DetailAlarm.vue?04431428